<form *ngVar="bannerValues$ | async as bannerValues" [formGroup]="form">
  @if (bannerValues.source) {
    <aux-investigator-forecast-saved-source-banner
      [source]="bannerValues.source"
      [amount]="bannerValues.amount"
    />
  }

  @if (flags().showEnrolledPatientsCostsTable) {
    <h2 class="my-5 text-2xl font-bold">Enrolled Patients</h2>
    <aux-investigator-forecast-table class="mb-5 block" />
  }

  <h2 class="mb-5 text-2xl font-bold">Select Source</h2>

  <div *ngVar="editMode$ | async as editMode" class="mb-4 flex items-start justify-between">
    <div class="flex items-center space-x-4">
      <div class="text-sm">Select Vendor Contract:</div>
      <aux-vendor-dropdown
        [vendors]="vendorList"
        formControlName="vendorId"
        [loading]="(vendorListLoading$ | async)!"
      />
    </div>
    <div class="flex space-x-2">
      <aux-button
        variant="secondary"
        icon="Eye"
        label="Forecast"
        (click)="viewForecastButtonClicked$.next(true)"
        [disabled]="editMode"
      ></aux-button>

      @if (editButtonTooltipErrors(); as errors) {
        @if (!editMode && !!form.getRawValue().vendorId) {
          <aux-button
            label="Edit"
            icon="Pencil"
            auxTooltip
            [template]="errors.length > 1 ? errorArrayTooltip : undefined"
            [auxTooltip]="errors.length === 1 ? errors[0] : ''"
            [disabled]="!!errors.length"
            [onClick]="editModeEnable()"
          />
        }
        <ng-template #errorArrayTooltip>
          <div class="rounded-[4px] py-2 pl-6 pr-4 text-white">
            <ul class="list-disc">
              @for (err of errors; track err) {
                <li>{{ err }}</li>
              }
            </ul>
          </div>
        </ng-template>
      }

      @if (editMode) {
        <aux-button label="Cancel" variant="secondary" icon="X" [onClick]="cancelEdit" />
      }
      @if (editMode) {
        <aux-button
          label="Save"
          variant="success"
          icon="Check"
          [disabled]="submitButtonDisabled$ | async"
          [onClick]="saveSiteContractSetting"
        />
      }
    </div>
  </div>

  <div class="relative grid grid-cols-[1fr_2fr]">
    <aux-investigator-forecast-source-select [control]="form.controls.source" [sources]="sources" />

    @if (!!form.getRawValue().source) {
      <aux-investigator-forecast-overview [form]="form" [formValues]="form.getRawValue()" />
    }
  </div>
</form>
